import React, { useEffect, useState } from "react";
import api from "../../../libs/axios";
import { INC_WORKFLOW_OPTIONS } from "../inc_sites";

const label = (v?: string) => (v ? INC_WORKFLOW_OPTIONS.find((o) => o.value === v)?.label || v : "");

const TimelineTab: React.FC<{ siteId: string }> = ({ siteId }) => {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/inc/sites/${siteId}/timeline`);
        setRows(res.data?.data || []);
      } finally {
        setLoading(false);
      }
    })();
  }, [siteId]);

  if (loading) return <p className="text-sm text-gray-500">Loading...</p>;
  if (rows.length === 0) return <p className="text-sm text-gray-500">No timeline events.</p>;

  return (
    <ol className="relative border-l border-gray-200 ml-3">
      {rows.map((r) => (
        <li key={r.id} className="mb-6 ml-6">
          <span className="absolute -left-1.5 flex items-center justify-center w-3 h-3 bg-blue-700 rounded-full mt-1.5" />
          <div className="flex items-center gap-2 flex-wrap">
            <span className="text-sm font-medium text-gray-800">{label(r.to_status) || r.to_status}</span>
            {r.from_status && <span className="text-xs text-gray-400">from {label(r.from_status) || r.from_status}</span>}
            <span className="px-2 py-0.5 text-[10px] uppercase tracking-wide bg-gray-100 text-gray-500 rounded">{r.action}</span>
          </div>
          <div className="text-xs text-gray-500 mt-0.5">
            {r.created_at ? new Date(r.created_at).toLocaleString() : ""}
            {r.performer ? ` · ${r.performer.first_name} ${r.performer.last_name}` : ""}
          </div>
          {r.remarks && <div className="text-sm text-gray-600 mt-1">{r.remarks}</div>}
        </li>
      ))}
    </ol>
  );
};

export default TimelineTab;
